import { MBView } from '@shared/components/MBView';
import { Text } from '@shared/components/Text';
import { Styles } from './styles';

export interface MBModalTitleProps {
  title: string;

  /*
        Does the modal have a shadow? If yes, the background color is set
        to white and there is a slight drop shadow below it. This makes
        the title stick out compared to the rest of the content. Suitable
        eg if the content isn't white
    */
  shadow?: boolean;

  // Selected props from MBModalProps
  onClose?: () => void;
  onBack?: () => void;
  isCloseButtonHidden?: boolean;
}

export function MBModalTitle({ title, shadow }: MBModalTitleProps) {
  return (
    <MBView
      row
      center
      paddingHorizontal={5}
      style={[Styles.title, shadow && Styles.titleWithShadow]}
    >
      <Text
        numberOfLines={1}
        align="center"
        weight="bold"
        style={{ fontSize: '18px', maxWidth: '100%' }}
      >
        {title}
      </Text>
    </MBView>
  );
}
